<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> برنامه سرویس </span>

    </div>

</div>

<main class="container-xxl">

    <form [formGroup]="searchModel" class="rtl w-100 row gx-2 gy-3 mt-2 p-2">
    
        <div class="col-12 col-md-2">
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input type="text" formControlName="strSDate" placeholder=" از تاریخ " class="form-control" />
    
            </ng-persian-datepicker>
    
        </div>

        <div class="col-12 col-md-2">
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input type="text" formControlName="strEDate" placeholder=" تا تاریخ " class="form-control" />
    
            </ng-persian-datepicker>
    
        </div>
    
        <div class="col-12 col-md-3">
    
            <select formControlName="iRoute" class="form-control">
    
                <option [value]="-1"> مسیر  </option>
    
                <option *ngFor="let item of list_Route" [value]="item.iRoute" > {{ item.strName }}  </option>
    
            </select>
    
        </div>

        <div class="col-12 col-md-1 text-end">
    
            <button class="btn w-100 px-3 btn-primary" (click)="get_Result()"> جستجو </button>
    
        </div>
    
        <div *ngIf="access.bRoute_Route_Schdeule_Save" class="col-12 col-md-1 text-end">
    
            <button class="btn w-100 px-3 btn-success" 
            
                (click)="new_Schedule()">
                
                افزودن 
            
            </button>
    
        </div>

        <div class="col-12 col-md-1 text-end">
    
            <button class="w-100 btn btn-secondary" 

                printTitle=" تعیین وضعیت برنامه سرویس "

                printSectionId="print-table-main"
            
                [useExistingCss]="true" ngxPrint>
                
                چاپ 
        
            </button>
    
        </div>

        <div *ngIf="access.bRoute_Route_Schdeule_Delete" class="col-12 col-md-auto text-end">
    
            <button class="btn w-100 px-3 btn-danger" (click)="removeSchedule_ByGroup()">
                
                حذف گروهی 
            
            </button>
    
        </div>
    
    </form> 
    
    <section class="border border-2 p-2 mt-4 dirI" style="max-height: 85vh;">

        <input type="text" class="w-100 my-3 form-control" placeholder="جستجو کنید...." (keyup)="filter_list($event.target)">
    
        <table class="col-12 table table-striped rounded-3" id="Export_Excel">
    
            <thead>
    
                <tr class="">
    
                    <th class="text-center col-1"> # </th>

                    <ng-container *ngIf="access.bRoute_Route_Schdeule_Delete">

                        <th class="text-center col-1 pointer" (click)="markAllSchedule()"> انتخاب </th>

                    </ng-container>

                    <ng-container *ngIf="access.bRoute_Route_Schdeule_Edit || access.bRoute_Route_Schdeule_Save || access.bRoute_Route_Schdeule_Delete">

                        <th class="text-center"> عملیات </th>

                    </ng-container>
        
                    <th class="text-center"> تاریخ </th>

                    <th class="text-center"> روز </th>
    
                    <th class="text-center"> نام مسیر </th>
                    
                    <th class="text-center"> کد خودرو </th>
    
                    <th class="text-center"> نام خودرو </th>
    
                    <th class="text-center"> موبایل راننده </th>
    
                    <th class="text-center"> ساعت شروع </th>

                    <th class="text-center"> ساعت پایان </th>
    
                    <th class="text-center"> انجام شده </th>
    
                </tr>
                
            </thead>

            <tbody>

                <tr *ngFor="let item of list_Result; let i=index" style="vertical-align: middle;">

                    <td class="col-1 text-center"> {{ i + 1 | faNum }} </td>

                    <ng-container *ngIf="access.bRoute_Route_Schdeule_Delete">

                        <td class="col-1 text-center">
                        
                            <input class="pointer" type="checkbox" [checked]="isScheduleSelected(item.iRoute_Schdeule)"
                            
                                (change)="markSchedule($event.target.checked,item)">
                        
                        </td>

                    </ng-container>

                    <ng-container *ngIf="access.bRoute_Route_Schdeule_Edit || access.bRoute_Route_Schdeule_Save || access.bRoute_Route_Schdeule_Delete">

                        <td class="f22 text-center d-flex justify-content-center align-items-center">

                            <i class="pointer fa fa-edit text-primary mx-1" 
                            
                                *ngIf="isEditValid(item)"
    
                                title="ویرایش" (click)="editModal(item,i)">
                            
                            </i>
    
                            <i *ngIf="access.bRoute_Route_Schdeule_Save"
                            
                                class="pointer mx-1" title=" تعیین وضعیت سرویس  " 
                            
                                (click)="open_RouteResult_Modal(item,i)">
    
                                <img width="19px" src="../../../assets/Img/check-list.png" alt="">
                            
                            </i>
    
                            <i *ngIf="access.bRoute_Route_Schdeule_Delete"
                            
                                class="pointer fa fa-trash text-danger mx-1"
                            
                                title="حذف" (click)="delete_Route(item,i)">
                            
                            </i>
    
                        </td>

                    </ng-container>

                    <td class="text-center"> {{ item.strDate | faNum }} </td>

                    <td class="text-center"> {{ item.strDay | faNum }} </td>

                    <td class="text-center"> {{ item.strName | faNum }} </td>

                    <td class="text-center"> {{ item.strUnitID | faNum }} </td>

                    <td class="text-center"> {{ item.strFullName | faNum }} </td>

                    <td class="text-center"> {{ item.strMobile | faNum }} </td>

                    <td class="text-center"> {{ item.strSTime | faNum }} </td>

                    <td class="text-center"> {{ item.strETime | faNum }} </td>

                    <td class="text-center"> {{ item.bDone ? '✅' : '❌' }} </td>

                </tr>

            </tbody>
    
        </table>
    
    </section>

</main>

<!-- افزودن برنامه ریزی -->

<div class="modal fade" id="schedule-modal" tabindex="-1" aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">
  
      <div class="modal-content p-1">
  
        <div class="modal-header dirI">
  
          <h5 class="modal-title"> {{ editMode ? 'ویرایش' : 'افزودن' }} برنامه سرویس </h5>
  
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  
        </div>
  
        <div class="modal-body dirI">

            <form [formGroup]="scheduleModel" class="row gx-3 gy-2 px-2">

                <div class="col-12 col-md-6 position-relative">

                    <label> متحرک </label>

                    <custom-filter *ngIf="showFilter"

                        [strValue]="returnStrValue('strFullName',scheduleModel.get('strFullName')?.value,list_Car,'strFullName')"
                
                        [strComment]="'strFullName'"
                
                        [stylesArray]="['padding-top: 13px']"
                
                        [str_Placeholder]="'نام متحرک را جستجو کنید'"
                
                        [lst_Main]="list_Car" 
                
                        [lst_SearchKey]="['strFullName']"
                
                        [isDisabled]="false"
                        
                        (hideOptions)="choose_Car($event)">
        
                    </custom-filter>

                </div>

                <div class="col-12 col-md-6 position-relative">

                    <label> مسیر </label>

                    <custom-filter *ngIf="showFilter"

                        [strValue]="returnStrValue('strName',scheduleModel.get('strRoute')?.value,list_Route,'strName')"
                
                        [strComment]="'strName'"
                
                        [stylesArray]="['padding-top: 13px']"
                
                        [str_Placeholder]="'نام مسیر را جستجو کنید'"
                
                        [lst_Main]="list_Route" 
                
                        [lst_SearchKey]="['strName']"
                
                        [isDisabled]="false"
                        
                        (hideOptions)="choose_Route($event)">
    
                    </custom-filter>

                </div>

                <ng-container *ngIf="!editMode">

                    <div class="col-12 col-md-6">

                        <label> از تاریخ  </label>
    
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                             [dateFormat]="'jYYYY/jMM/jDD'" [dateInitValue]="false" >
    
                             <input type="text" formControlName="strSDate" class="form-control text-end"/>
    
                        </ng-persian-datepicker>
    
                    </div>
    
                    <div class="col-12 col-md-6">
    
                        <label> تا تاریخ  </label>
    
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                             [dateFormat]="'jYYYY/jMM/jDD'" [dateInitValue]="false">
    
                             <input type="text" formControlName="strEDate" class="form-control text-end"/>
    
                        </ng-persian-datepicker>
    
                    </div>

                </ng-container>

                <ng-container *ngIf="editMode">

                    <div class="col-12 col-md-6">
    
                        <label>  تاریخ  </label>
    
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                             [dateFormat]="'jYYYY/jMM/jDD'">
    
                             <input type="text" formControlName="strDate" class="form-control text-end"/>
    
                        </ng-persian-datepicker>
    
                    </div>

                </ng-container>

                <div class="col-12 col-md-6">

                    <label> ساعت شروع  </label>

                    <div class="input-group clockpicker">

                        <input type="text" class="form-control text-center" id="strSTime" value="00:00" formControlName="strSTime">

                        <span class="input-group-addon ">

                            <span class="glyphicon glyphicon-time"></span>

                        </span>

                    </div>

                </div>

                <div class="col-12 col-md-6">

                    <label> ساعت پایان  </label>

                    <div class="input-group clockpicker">

                        <input type="text" class="form-control text-center" id="strETime" value="00:00" formControlName="strETime">

                        <span class="input-group-addon ">

                            <span class="glyphicon glyphicon-time"></span>

                        </span>

                    </div>

                </div>

                <div class="col-12">

                    <label> توضیحات </label>

                    <textarea style="height: 100px; max-height: 100px;"class="form-control dirI" formControlName="strComment">
                    
                    </textarea>

                </div>

                <div class="col-12 text-end mb-2" >

                    <button class="col-12 col-md-2 btn rounded" [ngClass]="editMode ? 'btn-primary' : 'btn-success' " (click)="editMode ? edit_Schedule() : save_Schedule() ">

                        <span class="px-2"> {{ editMode ? ' ویرایش ' : ' ذخیره ' }}   </span>
    
                    </button>

                </div>

            </form>
    
        </div>
  
      </div>
  
    </div>
  
</div>

<!-- تعیین وضعیت سرویس  -->

<div class="modal fade" id="routeResult-modal" tabindex="-1" aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-sm">
  
      <div class="modal-content p-1">
  
        <div class="modal-header dirI">
  
          <h5 class="modal-title"> تعیین وضعیت سرویس </h5>
  
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  
        </div>
  
        <div class="modal-body">

            <div class="row gx-2 gy-3 gy-md-0 p-2 mb-2 justify-content-between rounded">

                <div class="col-12 d-flex flex-column justify-content-start">

                    <span class="d-flex align-items-center justify-content-end">

                        <span class="mx-1"> سرویس انجام شد </span>
    
                        <input type="radio" name="bResult" [(ngModel)]="bResult" [value]="true">  
    
                    </span>
    
                    <span class="mt-2 d-flex align-items-center justify-content-end">
    
                        <span class="mx-1"> سرویس انجام نشد </span>
    
                        <input type="radio" name="bResult" [(ngModel)]="bResult" [value]="false">  
    
                    </span>

                </div>

            </div>

        </div>

        <div class="modal-footer">

            <div class="col-12 d-flex justify-content-start">

                <button class="btn btn-success px-3" (click)="update_RouteStatus(bResult)">

                    ذخیره

                </button>

            </div>

        </div>
  
      </div>
  
    </div>
  
</div>

<!-- چاپ برنامه سرویس -->

<div class="d-none table-responsive dirI rounded-3 p-2 my-2" id="print-table-main">

    <table class=" table table-striped dirI border border-2">

        <thead class="table-header">

            <tr class="col-12 text-center">

                <th scope="col" class=""> نوع خودرو </th>

                <th scope="col" class=""> مقصد </th>

                <th scope="col" class=""> مبدا </th>

                <th scope="col" class=""> ساعت خروج از مبدا </th>

                <th scope="col" class=""> راننده </th>

                <th scope="col" class=""> نفرات </th>

            </tr>

        </thead>

        <tbody>

            <tr class="col-12 text-center f14" *ngFor="let item of list_Result;">

                <td scope="col" class=""> {{ item.strMobileType_strComment | faNum }} </td>

                <td scope="col" class=""> {{ item.strDestinationStationName | faNum }} </td>

                <td scope="col" class=""> {{ item.strSourceStationName | faNum }} </td>

                <td scope="col" class=""> {{ item.strSourceETime ? (item.strSourceETime | faNum) : '- - -  - -' }} </td>
                
                <td scope="col" class=""> {{ item.strFullName | faNum }} </td>

                <td scope="col" class=""> - - -  - - </td>

            </tr>

        </tbody>


    </table>

</div>